import api from './api.js'
import chats from './chats.js'
import drafts from './drafts.js'
import federationRestrictions from './federationRestrictions.js'
import notifications from './notifications.js'
import profileConfig from './profileConfig.js'
import statuses from './statuses.js'
import users from './users.js'

export default {
  statuses,
  notifications,
  users,
  api,
  profileConfig,
  drafts,
  chats,
  federationRestrictions,
}
